import './App.css';
import React, {useState, useContext} from 'react'
import {QuizContext} from "./Helpers/Contexts"

import MainMenu from './Components/MainMenu';
import Quiz from './Components/Quiz';
import EndScreen from './Components/EndScreen';


function App() {
  const [gameState, setGameState] = useState("menu");
  const [score, setScore] =  useState(0);
  const [name, setName] =  useState("");

  return (
    <div>
    
    <QuizContext.Provider value={{ gameState, setGameState, score, setScore, name, setName }}>
    {gameState === "menu" && <MainMenu />}
    {gameState === "quiz" && <Quiz/>}
    {gameState === "end" && <EndScreen/>}
    </QuizContext.Provider>
    
    </div>
  );
}

export default App;